import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, nextTick } from 'vue';
  import VCharts from 'vue-echarts';
  // import { useAppStore } from '@/store';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
  },
  setup(__props) {

  
  // const appStore = useAppStore();
  // const theme = computed(() => {
  //   if (appStore.theme === 'dark') return 'dark';
  //   return '';
  // });
  const renderChart = ref(false);
  // wait container expand
  nextTick(() => {
    renderChart.value = true;
  });

return (_ctx: any,_cache: any) => {
  return (renderChart.value)
    ? (_openBlock(), _createBlock(_unref(VCharts), {
        key: 0,
        option: __props.options,
        autoresize: __props.autoResize,
        style: _normalizeStyle({ width: __props.width, height: __props.height })
      }, null, 8, ["option", "autoresize", "style"]))
    : _createCommentVNode("", true)
}
}

})